import { Endpoint } from '../endpoint';
import { ManagementFormID, ManagementFormCommentResponse, CommentId, ManagementFormResponse } from '@business/entities/managementForms';
import { UserId } from '@business/entities/account';

export function fetchComments(formId: ManagementFormID, isCompact?: boolean) {
  return Endpoint.get<ManagementFormCommentResponse[]>(`@makh/management-form-comments/${formId}`, { params: { isCompact } });
}

export function fetchComment(id: CommentId) {
  return Endpoint.get<ManagementFormCommentResponse>(`@makh/management-form-comments/comment/${id}`);
}

export function createComment(data: { formId: ManagementFormID; comment: string; user: UserId }) {
  return Endpoint.post<ManagementFormResponse>(`@makh/management-form-comments`, { data });
}

export function deleteComment(commentId: CommentId) {
  return Endpoint.delete<void>(`@makh/management-form-comments/${commentId}`);
}
